var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeekLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15.21,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.2162 9.21997C3.16019 9.21997 3.11821 9.20598 3.0762 9.17795C1.91417 8.51997 1.2002 7.30195 1.2002 5.99995C1.2002 3.98395 2.8522 2.34595 4.8962 2.34595H10.1182C10.2862 2.34595 10.4122 2.47196 10.4122 2.63994C10.4122 2.80791 10.2862 2.93392 10.1182 2.93392H4.8962C3.1742 2.93392 1.7882 4.30592 1.7882 5.99992C1.7882 7.09195 2.39022 8.11392 3.3702 8.65992C3.5102 8.74391 3.56621 8.92594 3.48221 9.06594C3.4262 9.16392 3.32818 9.21992 3.2162 9.21992L3.2162 9.21997Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.104 9.65394H4.89604C4.72806 9.65394 4.60205 9.52793 4.60205 9.35995C4.60205 9.19197 4.72806 9.06596 4.89604 9.06596H10.118C11.826 9.06596 13.212 7.69396 13.212 5.99996C13.212 4.90794 12.61 3.88596 11.63 3.33996C11.49 3.25597 11.434 3.07395 11.518 2.93395C11.602 2.79395 11.784 2.73794 11.924 2.82193C13.0861 3.47995 13.8 4.69793 13.8 5.99993C13.8 8.01593 12.148 9.65394 10.104 9.65394Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.64841 4.60002C8.57841 4.60002 8.50841 4.57204 8.4524 4.53002C8.32639 4.418 8.3124 4.23603 8.42442 4.11002L9.71242 2.64002L8.41042 1.17002C8.2984 1.04401 8.31244 0.862042 8.4384 0.750019C8.56441 0.638 8.74638 0.652038 8.8584 0.778L10.3284 2.444C10.4264 2.55602 10.4264 2.724 10.3284 2.83602L8.8584 4.50202C8.80244 4.57202 8.7184 4.6 8.6484 4.6L8.64841 4.60002Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.35211 11.32C6.26812 11.32 6.18413 11.292 6.12812 11.222L4.67212 9.55601C4.57414 9.44399 4.57414 9.27601 4.67212 9.16399L6.14212 7.49799C6.25414 7.37198 6.43611 7.35799 6.56212 7.47001C6.68813 7.58203 6.70212 7.76399 6.5901 7.89001L5.2881 9.36001L6.5901 10.83C6.70212 10.956 6.68808 11.138 6.56212 11.25C6.49212 11.292 6.42212 11.32 6.35212 11.32L6.35211 11.32Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeekLink);
export default __webpack_public_path__ + "static/media/weekLink.13a4ddac8db73e68855f5202b650466a.svg";
export { ForwardRef as ReactComponent };